
export default class AdProvider_Admob_Plus {
    constructor(appId, interstitialAdId, rewardedAdId, appOpenAdId, onAdLoaded, onAdOpened, onAdClosed, onAdError) {
        this.appId = appId;
        this.interstitialAdId = interstitialAdId;
        this.rewardedAdId = rewardedAdId;
        this.appOpenAdId = appOpenAdId;

        this.onAdLoaded = onAdLoaded;
        this.onAdOpened = onAdOpened;
        this.onAdClosed = onAdClosed;
        this.onAdError = onAdError;

        this.interstitialAd = null;
        this.rewardedAd = null;
        this.appOpenAd = null;

        this.interstitialAdAdAutoShow = false;
        this.rewardedAdAutoShow = true;
        this.appOpenAdAutoShow = true;
    }
    isReady() {
        if (admob === undefined || !admob) {
            console.log('admob plugin not ready');
            return false;
        }
        return true;
    }
    async setup() {
        //todo: wait until the plugin is ready or timeout
        if (!this.isReady()) return false;

        //one once per page load 
        if (this.isSetup) {
            console.log('Admob.isSetup is already done');
            return true;
        }
        // if (cordova.platformId === 'ios') {
        //     const status =  await admob.requestTrackingAuthorization().then(console.log);
        //     console.log('Tracking Authorization: ' + status);
        // }

        await admob.start() // or start loading ads

        //interstitial ad
        this.interstitialAd = new admob.InterstitialAd({
            adUnitId: this.interstitialAdId
        });
        this.interstitialAd.on('load', (evt) => {
            console.log("onAdLoaded: " + evt);
            if (this.onAdLoaded) this.onAdLoaded({ adType: "interstitial" });
        });
        this.interstitialAd.on('loadfail', (evt) => {
            //todo: handle error
            if (this.onAdError) this.onAdError({ error: evt, adType: "interstitial" });
        });
        this.interstitialAd.on('show', (evt) => {
            console.log("onAdOpened", evt);
            if (this.onAdOpened) this.onAdOpened({ adType: "interstitial" });
        });
        this.interstitialAd.on('showfail', (evt) => {
            //todo: handle error
            if (this.onAdError) this.onAdError({ error: evt, adType: "interstitial" });
        });
        this.interstitialAd.on('dismiss', (evt) => {
            console.log("onAdClosed: " + evt);
            if (this.onAdClosed) this.onAdClosed({ adType: "interstitial" });
        });
        //rewarded ad
        this.rewardedAd = new admob.RewardedAd({
            adUnitId: this.rewardedAdId,
        });
        this.rewardedAd.on('load', (evt) => {
            console.log("onAdLoaded: " + evt);
            if (this.onAdLoaded) this.onAdLoaded({ adType: "rewarded" });
        });
        this.rewardedAd.on('loadfail', (evt) => {
            //todo: handle error
            if (this.onAdError) this.onAdError({ error: evt, adType: "rewarded" });
        });
        this.rewardedAd.on('show', (evt) => {
            console.log("onAdOpened", evt);
            if (this.onAdOpened) this.onAdOpened({ adType: "rewarded" });
        });
        this.rewardedAd.on('showfail', (evt) => {
            //todo: handle error
            if (this.onAdError) this.onAdError({ error: evt, adType: "rewarded" });
        });
        this.rewardedAd.on('reward', (evt) => {
            console.log("onAdClosed: " + evt);
            if (this.onAdClosed) this.onAdClosed({ adType: "rewarded", rewardAmount: 150 });
        });

        //app open ad
        this.appOpenAd = new admob.AppOpenAd({
            adUnitId: this.appOpenAdId,
        });

        this.isSetup = true;

        return true;
    };
    async loadAd() {
        console.log("Admob.loadAd");

        if (!this.isReady()) return false;

        if (!this.isSetup) await this.setup();

        let isAdLoaded = await this.interstitialAd.isLoaded();

        if (!isAdLoaded)
            await this.interstitialAd.load();
    };
    async showAd() {
        console.log("Admob.showAd");

        if (!this.isReady()) return false;

        if (!this.isSetup) await this.setup();

        let isAdLoaded = await this.interstitialAd.isLoaded();

        if (isAdLoaded) {
            await this.interstitialAd.show();
        }
        else {
            if (this.interstitialAdAutoShow) {
                await this.interstitialAd.load()
                await this.interstitialAd.show();
            } else {
                await this.interstitialAd.load();
            }
        }
    };
    async isAdLoaded() {
        return this.interstitialAd.isLoaded();
    };
    async isRewardedAdLoaded() {
        return this.rewardedAd.isLoaded();
    };
    async showRewardedAd() {
        console.log("Admob.ShowRewardedAd");

        if (!this.isReady()) return false;

        if (!this.isSetup) await this.setup();

        let isAdLoaded = await this.rewardedAd.isLoaded();

        if (isAdLoaded) {
            await this.rewardedAd.show();
        }
        else {
            await this.rewardedAd.load().then(() => {
                if (this.rewardedAdAutoShow) this.rewardedAd.show();
            });
        }
    };
    async loadRewardedAd() {
        console.log("Admob.loadRewardedAd");

        if (!this.isReady()) return false;

        if (!this.isSetup) await this.setup();

        let isAdLoaded = await this.rewardedAd.isLoaded();

        if (!isAdLoaded)
            await this.rewardedAd.load();
        if (isAdLoaded)
            console.log('requestRewardedAd is already loaded');

    };
    async showAppOpenAd() {
        console.log("Admob.ShowAppOpenAd");

        if (!this.isReady()) return false;

        if (!this.isSetup) await this.setup();

        let isAdLoaded = await this.appOpenAd.isLoaded();

        if (isAdLoaded) {
            await this.appOpenAd.show();
        }
        else {
            await this.appOpenAd.load().then(() => {
                if (this.appOpenAdAutoShow) this.appOpenAd.show();
            });
        }
    };
    showMediationTestSuite() {

    }
    showAdInspector() {

    }
}


